import React from 'react';
import { useRouter } from 'next/navigation';
import { cn } from '@/utils/cn';
import useActivePath from '@/app/hooks/useActivePath';
import Button from '@/app/components/Button';
import { primaryNavItems } from '../menuList';
import TextBase from '../../Typography/TextBase';

function MainNavLink({ onMouseEnter = () => {}, onMouseLeave = () => {} }) {
  const router = useRouter();

  return (
    <div className="w-max hidden lg:flex justify-center items-center lg:gap-[27px]">
      {primaryNavItems?.map((item, index) => {
        const isFirstItem = index === 0;
        const isLastItem = index === primaryNavItems.length - 1;
        const isActive = useActivePath(item.path);

        return (
          <Button
            key={item?.key}
            type="link"
            className={cn(
              'group pl-18 pr-18 xl:pl-24 xl:pr-24 pb-32 lg:pb-20 pt-0 lg:translate-y-1',
              {
                'pl-34 xl:pl-40': isFirstItem,
                'pr-34 xl:pr-40': isLastItem,
              },
            )}
            onMouseEnter={() => {
              if (
                item.key !== 'campaign' &&
                item.key !== 'installmentoptions'
              ) {
                onMouseEnter(item?.key);
              }
            }}
            onMouseLeave={onMouseLeave}
            id="dropdownDefaultButton"
            data-dropdown-toggle="dropdown"
            onClick={() => router.push(item?.url)}
          >
            <TextBase
              text={item.name}
              className={cn(
                'font-medium whitespace-nowrap transition-all duration-100 ease-in-out relative after:transition-all after:duration-200 after:content-[""] after:w-full after:h-[2px] after:bg-transparent after:block after:absolute after:left-0 after:-bottom-[10px] group-hover:after:bg-richcarmine text-white',
                {
                  'after:bg-richcarmine': isActive,
                },
              )}
            />
          </Button>
        );
      })}
    </div>
  );
}

export default MainNavLink;
